import {
  BaseUXComponent,
  UXComponentType
} from '../UXComponentRenderer/uxComponent.types'
import { UXComponent } from '../UXComponentRenderer/uxComponent'
import { Button } from '../primitives/Button/Button.types'
import { Label } from '../primitives/Label/Label.types'
import { Text } from '../primitives/Text/Text.types'
import { Color, ColorValue } from '../styles/color.styles'

export enum SectionOrientation {
  HORIZONTAL = 'HORIZONTAL',
  VERTICAL = 'VERTICAL'
}

export type SectionAttributes = {
  title?: Label
  description?: Text
  button?: Button
  showBottomDivider: boolean
  showTopDivider: boolean
  backgroundColor?: Color | ColorValue
  content: UXComponent[]
  padding?: string
  orientation?: SectionOrientation
}

export type Section = BaseUXComponent<UXComponentType.Section> & {
  attributes: SectionAttributes
}
